module.exports = __webpack_public_path__ + "img/iomico_logo_1.0cc7f728.svg";